import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_PT1_BG: TStep[] = [
  {
    pageId: PageId.DOG_SEX_PT1_BG,
  },
  {
    pageId: PageId.DOG_AGE_PT1_BG,
  },
  {
    pageId: PageId.SHELTER_PT1_BG,
  },
  {
    pageId: PageId.DOG_BREED_PT1_BG,
  },
  {
    pageId: PageId.URGE_PT1_BG,
  },
  {
    pageId: PageId.STARTED_PT1_BG,
  },
  {
    pageId: PageId.PLACE_PT1_BG,
  },
  {
    pageId: PageId.GOALS_PT1_BG,
  },
  {
    pageId: PageId.ACCIDENTS_PT1_BG,
  },
  {
    pageId: PageId.CONCERNS_PT1_BG,
  },
  {
    pageId: PageId.URGE_2_PT1_BG,
  },
  {
    pageId: PageId.LIVING_SITUATION_PT1_BG,
  },
  {
    pageId: PageId.POTTY_BREAKS_PT1_BG,
  },
  {
    pageId: PageId.CRATE_TRAINING_PT1_BG,
  },
  {
    pageId: PageId.COMMANDS_PT1_BG,
  },
  {
    pageId: PageId.TRAINING_TIME_PT1_BG,
  },
  {
    pageId: PageId.PREPARE_FLOW_PT1_BG,
  },
  {
    pageId: PageId.COMMITMENT_SCREEN_PT1_BG,
  },
  {
    pageId: PageId.EMAIL_PT1_BG,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_PT1_BG,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_PT1_BG,
  },
  {
    pageId: PageId.CANCEL_OFFER_PT1_BG,
  },
  {
    pageId: PageId.CHAT_UPSELL_PT1_BG,
  },
  {
    pageId: PageId.UPSELL_PT1_BG,
  },
  {
    pageId: PageId.UPSELL_FEEDING_GUIDE_PT1_BG,
  },
  {
    pageId: PageId.UPSELL_EMOTIONAL_SUPPORT_PT1_BG,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
  {
    pageId: PageId.DOWNLOAD_PT1_BG,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PT1_BG.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)
